module.exports = require('./TaskAssignModalView');
